module.exports = require('./TaskAssignModalView');
